<template>
  <div class="mt-4">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            class="w-full mb-4"
            color="info"
            @click="generate_travel_order()"
          >
            Re-Print Job Order
          </v-btn>
          <v-select
            v-model="options"
            dense
            outlined
            label="Service Type"
            :items="options_items"
            :rules="rules.combobox_rule"
            item-value="type_of_service"
            item-text="type_of_service"
            @change="selected_service_type"
          ></v-select>
          <v-text-field
            label="Search Service"
            placeholder="Press Enter to Search"
            required
            v-model="search_menu"
          ></v-text-field>
          <v-data-table dense
                        :headers="headers"
                        :items="services_items"
                        :search="search_menu"
          >
            <template v-slot:item="{ item }">
              <tr
                @click="activerow(item)"
                :class="{'info black--text': item.id===selectedDepositId}"
              >
                <td>
                  {{ item.service_name }}
                </td>
                <td>
                  {{ formatPrice(item.amount) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="12" md="8">
          <menu-datas
            :key="this.menus_data.length"
            :menus_data="this.menus_data"
            :is_can_delete="true"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog persistent v-model="is_menu_selected" max-width="500px">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title
          ><h4 class="font-weight-light">SERVICES SECTION</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" class="multi-col-validation mt-6">
          <v-card-text class="mt-4">
            <v-text-field
              label="How Many Unit in this Service"
              required
              outlined
              v-model="order_quantity"
              type="number"
              min="0"
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
            <v-text-field
              v-if="parseFloat(order_selected.amount)===0"
              label="Amount Per unit"
              required
              outlined
              v-model="order_amount"
              type="number"
              min="0"
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <!-- alert -->
              <v-col cols="12" v-show="alert">
                <v-alert
                  color="warning"
                  text
                  class="mb-0"

                >
                  <div class="d-flex align-start">
                    <v-icon color="warning">
                      {{ icons.mdiAlertOutline }}
                    </v-icon>

                    <div class="ms-3">
                      <p class="text-base font-weight-medium mb-1">
                        {{ alert_message }}
                      </p>
                    </div>
                  </div>
                </v-alert>
              </v-col>
              <v-col cols="12" md="12">
                <v-btn
                  color="primary" class="w-full" @click="save_order">
                  Save Changes
                </v-btn>
              </v-col>
              <v-col cols="12" md="12">
                <v-btn
                  color="error" class="w-full" @click="is_menu_selected=false">
                  Close
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiAlertOutline, mdiCloudUploadOutline
  , mdiAccountSearchOutline
  , mdiDelete
} from '@mdi/js'
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import MenuDatas from '@/views/cashier_interface/order_transaction/components/Confirmation'

const initialState = () => {
  return {
    saving: false,
    alert: false,
    alert_message: '',

    options: '',

    order_quantity: '1',
    order_amount: '1',
    total_amount: '0.00',

    is_deleting: false,
    is_menu_selected: false,
    selectedDepositId: -1,
    search_menu: '',
    menus_data: [],
    services_items: [],
    order_selected: {},
    headers: [
      {text: 'MENU', value: 'service_name', sortable: false},
      {text: 'AMOUNT', value: 'amount', sortable: false},
    ],
  }
}
export default {
  props: {
    menus_order: Array,
    options_items: Array,
    type_of_service: String,
    purpose: String,
    selected_table: Object,
  },
  components: {
    MenuDatas,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiAccountSearchOutline,
        mdiDelete,
      },
    }
  },
  data() {
    return initialState()
  },
  async mounted() {
    this.menus_data = this.menus_order
    this.over_all_total()
  },
  watch: {
    menus_data: function () {
      this.$emit('data', {
        menus_data: this.menus_data,
      })
    },
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text']),
    ...mapGetters('authentication', ['user_id', 'branch_id']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('menu_order', ['get_available_service']),
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    over_all_total() {
      this.total_amount = '0.00'
      var tot = 0
      this.menus_data.forEach(function (item) {
        tot += parseFloat(item.total)
      })
      this.total_amount = this.formatPrice(tot)
    },
    selected_service_type() {
      this.get_available_service({
        branch_id: this.branch_id,
        type_of_service: this.options,
      })
        .then(response => {
          this.services_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    activerow(item) {
      this.order_selected = item
      this.selectedDepositId = item.id
      this.is_menu_selected = true
    },
    save_order() {
      this.alert = false
      if (parseFloat(this.order_quantity) <= 0) {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      } else if (parseFloat(this.order_amount) <= 0 && parseFloat(this.order_selected.amount) === 0) {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      } else if (this.$refs.form.validate()) {
        this.is_menu_selected = false
        this.menus_data.push({
          id: 0,
          service: this.order_selected,
          amount: parseFloat(this.order_selected.amount) === 0 ? parseFloat(this.order_amount) : this.order_selected.amount,
          total: parseFloat(this.order_quantity * (parseFloat(this.order_selected.amount) === 0 ? parseFloat(this.order_amount) : this.order_selected.amount)),
          type_of_service: this.type_of_service,
          purpose: this.purpose,
          quantity: this.order_quantity,
          done: moment().format('YYYY-MM-DD-HH-mm-ss'),
        })
        this.over_all_total()
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      }
    },
    async generate_travel_order() {
      this.$emit('job_order', this.selected_table)
    },
  },
}
</script>
